<!-- <app-loading-spinner *ngIf="loading"></app-loading-spinner> -->
<!-- <router-outlet *ngIf="!loading"></router-outlet> -->
<router-outlet></router-outlet>